import state from './moduleCategoryManagementState.js'
import mutations from './moduleCategoryManagementMutations.js'
import actions from './moduleCategoryManagementActions.js'
import getters from './moduleCategoryManagementGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters

}

